/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".logoColumn[_ngcontent-%COMP%]{padding-top:25px}.titlesContainer[_ngcontent-%COMP%] > h4[_ngcontent-%COMP%]{font-size:15px!important}.title-phone[_ngcontent-%COMP%]{font-size:13px!important}.titlesContainer[_ngcontent-%COMP%] > h6[_ngcontent-%COMP%]{font-size:12px!important}"];
export { styles as styles };
